import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PassingSxProp from './PassingSxProp';
import ClientProvider from './client';
export default createDemo(import.meta.url, PassingSxProp, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/getting-started/the-sx-prop/demos/passing-sx-prop/PassingSxProp.tsx",
    "fileName": "PassingSxProp.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport ListItem from '@mui/material/ListItem';\nimport FormLabel from '@mui/material/FormLabel';\nimport type { SxProps, Theme } from '@mui/material/styles';\n\ninterface ListHeaderProps {\n  children: React.ReactNode;\n  sx?: SxProps<Theme>;\n}\n\nfunction ListHeader({ sx = [], children }: ListHeaderProps) {\n  return (\n    <ListItem\n      sx={[\n        {\n          width: 'auto',\n          textDecoration: 'underline',\n        },\n        // `sx` can itself be an array, so flatten it before spreading.\n        ...[sx].flat(),\n      ]}\n    >\n      <FormLabel sx={{ color: 'inherit' }}>{children}</FormLabel>\n    </ListItem>\n  );\n}\n\nexport default function PassingSxProp() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ListHeader\n      sx={(theme) => ({\n        color: 'info.main',\n        ...theme.typography.overline,\n      })}\n    >\n      Header\n    </ListHeader>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 39,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport ListItem from '@mui/material/ListItem';\nimport FormLabel from '@mui/material/FormLabel';\nimport type { SxProps, Theme } from '@mui/material/styles';\n\ninterface ListHeaderProps {\n  children: React.ReactNode;\n  sx?: SxProps<Theme>;\n}\n\nfunction ListHeader({ sx = [], children }: ListHeaderProps) {\n  return (\n    <ListItem\n      sx={[\n        {\n          width: 'auto',\n          textDecoration: 'underline',\n        },\n        // `sx` can itself be an array, so flatten it before spreading.\n        ...[sx].flat(),\n      ]}\n    >\n      <FormLabel sx={{ color: 'inherit' }}>{children}</FormLabel>\n    </ListItem>\n  );\n}\n\nexport default function PassingSxProp() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ListHeader\n      sx={(theme) => ({\n        color: 'info.main',\n        ...theme.typography.overline,\n      })}\n    >\n      Header\n    </ListHeader>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ListHeader"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "(",
              [
                "span",
                "pl-v di-jv",
                "theme"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ({"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "        ",
              [
                "span",
                "di-op di-jv",
                "color"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "info.main",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 33
            },
            [
              "        ",
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "typography"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "overline"
              ],
              ","
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 34
            },
            [
              "      })",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 35
            },
            "    >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 36
            },
            "      Header"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 37
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ListHeader"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 39,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/ListItem",
      "@mui/material/FormLabel",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
